export function getCoordinateInterval(width: number, basesOnScreen: number): number {
  const baseIntervals = [1, 2, 5, 10, 20, 50];
  const targetTicks = Math.floor(width / 90) ?? 1;
  let interval = 1;

  while (basesOnScreen / interval > targetTicks) {
    interval *= 10;
  }

  for (let i = baseIntervals.length - 1; i >= 0; i--) {
    if (basesOnScreen / (interval / baseIntervals[i]) <= targetTicks) {
      interval /= baseIntervals[i];
      break;
    }
  }

  return Math.max(5, interval);
}
